<script>
import { GeoJSON } from 'ol/format'
import VectorSource from 'ol/source/Vector'

// 图形样式
const defaultEffect = {
  fill: '#143f28',
  stroke: {
    color: '#ffec43', // 绿色
    width: 6
  },
  text: {
    fill: 'blue',
    stroke: {
      color: '#fff',
      width: 3
    },
    text: '',
    textAlign: 'center',
    textBaseline: 'middle',
    font: 'bold 20px serif',
    offsetX: 0,
    offsetY: 0
  }
}

export default {
  name: 'ol-source-vector',

  inject: ['getLayer'],

  props: {
    url: {
      type: String,
      default: ''
    },
    layers: {
      type: String,
      default: ''
    },
    filter: {
      type: String,
      default: ''
    },
    // 图形样式
    effect: {
      type: [Object, Function],
      default() {
        return defaultEffect
      }
    }
  },

  watch: {
    layers(newVal) {
      this.vectorSource.setUrl(newVal)
      this.vectorSource.refresh()
    },
    filter(newVal) {
      console.log('filter监听',newVal);

      const sourceParam = {
        version: "1.1.0",
        service: "WFS",
        request: "GetFeature",
        outputFormat: "application/json",
        typeName: this.layers,
      };
      // this.filter = 'project_id=1847679905477128193 and data_date=2024-10-09'
      this.__updateSourceParam(sourceParam, newVal);

      const fullUrl = this.joinUrlParam(this.baseUrl + "ows", sourceParam);
      this.vectorSource.setUrl(fullUrl)
      this.vectorSource.refresh()
    }
  },

  data() {
    return {
      vectorSource: null,
      baseUrl: 'http://120.46.44.187:8090/geoserver/henan/'
    }
  },

  created() {
    console.log('this.url', this.url);
    const sourceParam = {
      version: "1.1.0",
      service: "WFS",
      request: "GetFeature",
      outputFormat: "application/json",
      typeName: this.layers,
    };
    // this.filter = 'project_id=1847679905477128193 and data_date=2024-10-09'
    this.__updateSourceParam(sourceParam, this.filter);

    const fullUrl = this.joinUrlParam(this.baseUrl + "ows", sourceParam);
    this.vectorSource = new VectorSource({
      url: function (extent, resource, project) {
        return fullUrl;
      },
      format: new GeoJSON(),
    })

    this.getLayer(layer => {
      layer.setSource(this.vectorSource)
    })
  },

  beforeDestroy() {
    this.vectorSource = null
  },

  render() {
    return null
  },
  methods: {
    joinUrlParam(rootUrl, params) {
      let url = rootUrl + "?";
      for (var key in params) {
        url = url + key + "=" + params[key] + "&";
      }
      url = url.slice(0, -1);
      return url;
    },
    __updateSourceParam(sourceParam, cqlFilter) {
      /**
       * 更新图层源参数；接口秘钥、cqlFilter过滤参数
       */

      // 秘钥
      // sourceParam[this.tokenKey] = this.tokenValue;

      // 过滤参数
      if (!!cqlFilter) {
        sourceParam["cql_filter"] = cqlFilter;
      }
    },
  }
}
</script>
